import { render, staticRenderFns } from "./FiscalizacaoIrregularidadeDetalhe.vue?vue&type=template&id=2cfa196d&"
import script from "./FiscalizacaoIrregularidadeDetalhe.vue?vue&type=script&lang=js&"
export * from "./FiscalizacaoIrregularidadeDetalhe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports